import { render, staticRenderFns } from "./CmsB2BGroupsActivityTable.vue?vue&type=template&id=c0c80eee&scoped=true"
import script from "./CmsB2BGroupsActivityTable.vue?vue&type=script&lang=ts"
export * from "./CmsB2BGroupsActivityTable.vue?vue&type=script&lang=ts"
import style0 from "./CmsB2BGroupsActivityTable.vue?vue&type=style&index=0&id=c0c80eee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c80eee",
  null
  
)

export default component.exports